<template>
  <div style="padding:0 10px;">
    <el-row v-if="false" type="flex" align="middle">
      <el-col :span="3">
        <div style="font-weight: bold;font-size: 16px;padding:10px;">患者床位</div>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" size="small" @click="showBed('包床')">追加</el-button>
      </el-col>
      <el-col :span="4">
        <el-checkbox style="margin-left:20px;" v-model="ifShowHistory" @change="getHasBed">显示历史床位</el-checkbox>
      </el-col>
    </el-row>
    <el-table style="margin-top:10px;" :data="wrapBedList" border @expand-change="getItems" v-loading='meta.loading'>
      <el-table-column type="expand" width="50" key="expand">
        <template slot-scope="{ row }">
          <el-table :span-method="arraySpanMethod" style="width:500px;min-height:100px;" sttmin-height="60px;" border :data="row.children" class="main-table">
            <el-table-column align="center" label="操作" width="50px;">
              <template slot-scope="props">
                <i v-if="props.row.name !== 'add'" class="el-icon-error rotate font20 cursorP" style="color:red;" @click="delItems(row,props.row)"></i>
                <i v-if="props.row.name == 'add'" class="el-icon-circle-plus-outline rotate font20 cursorP" @click="addItems(row)"></i>
              </template>
            </el-table-column>
            <el-table-column align="center" label="收费项目" prop="name">
              <template slot-scope="props">
                <div v-if="props.row.name !== 'add'">{{props.row.name}}</div>
                <div v-else>
                  <el-select v-model="selFeeCode" filterable remote clearable reserve-keyword placeholder="请输入关键词" :remote-method="querySearchAsync" :loading="meta.loading">
                    <el-option v-for="item in feeOptions" :key="item.lockKey" :label="item.name" :value="item.code"></el-option>
                  </el-select>
                  <!-- <el-autocomplete clearable v-model="row.state" :fetch-suggestions="querySearchAsync"  placeholder="请输入内容" @select="handleSelect">
                    <template slot-scope="{ item }">
                    <div class="name">{{ item.name }}</div>
                  </template>
                  </el-autocomplete> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="计价单位" prop="unit"></el-table-column>
            <el-table-column align="center" label="价格（元）" prop="price"> </el-table-column>
          </el-table>
        </template>
      </el-table-column>

      <el-table-column v-if="type=='转科'" align="center" label="操作" width="120px;">
        <template slot-scope="{ row }">
          <i v-if="!row.endTime" class="el-icon-sort rotate font20 cursorP" title="转床" @click="showBed('转床',row)"></i>
          <span v-if="!row.ifPrimary && !row.endTime" class="iconfont icon-chexiaobaochuang cursorP" style="margin-left:20px;" @click="cancelWarpBed(row.id)" title="取消包床"></span>
          <!-- <el-checkbox v-if="!row.ifPrimary && !row.endTime" style="margin-left:20px;" title="设置主床" @change="changeMainBed(row.bedId)"></el-checkbox> -->
        </template>
      </el-table-column>
      <el-table-column align="center" label="床位" prop="no">
        <template slot-scope="{ row }">
          <span style="margin-right:10px;">{{row.no}}</span>
          <!-- <el-tag v-if="row.ifPrimary && !row.endTime" size="mini">主</el-tag>
          <el-tag v-if="!row.ifPrimary && !row.endTime" size="mini">包</el-tag>
          <el-tag v-if="row.endTime"  size="mini" type="info">历史</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column align="center" label="开始日期" prop="startTime"></el-table-column>
      <el-table-column align="center" label="结算日期" prop="endTime"> </el-table-column>
    </el-table>
    <appendBed v-if="meta.showBed" :info="selInfo" :visible.sync="meta.showBed" @close="getHasBed"></appendBed>

  </div>
</template>

<script>
import api from "./api";
// import utils from "@/common/utils";
import { mapGetters } from "sw-hic";
export default {
  components: {
    appendBed: () => import("./dlgBedSelector")
  },
  props: {
    type:String,
    ipNo:String,
    patientCode:String,
    bedList:Array
  },
  data() {
    return {
      // state:'',
      ifShowHistory:false,
      wrapBedList:[],
      meta:{
        showBed:false,
        loading:false
      },
      selInfo:{},
      mainBedLogId:'',
      tempFee:null,
      showIds:[],
      selFeeCode:"",
      feeOptions:[]
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "dictEnum","user"])
  },
  filters:{},
  watch:{
    bedList(newV,old){
      this.getHasBed()
    }
  },
  mounted() {
    this.selInfo.ipNo = this.ipNo
    this.selInfo.patientCode = this.patientCode
  },
  methods: {
    async getHasBed(){
      this.meta.loading = true;
      this.wrapBedList = []
      let blist = this.bedList
      blist.forEach(element => {
        if(!element.endTime){
          element.children = [{name:"add"}]
        }
        
        if(element.ifPrimary && !element.endTime){
          this.mainBedLogId = element.id
        }
      });
      this.wrapBedList = blist
      this.meta.loading = false;
    },
    
    querySearchAsync(queryString, cb) {
      this.meta.loading = true
      api.FeeStandard.query({name:queryString}).then(res=>{
        setTimeout(()=>{
          this.feeOptions = res.items
          this.meta.loading = false
        },1000)
      }).catch((err)=>{
        this.meta.loading = false
        this.$message.error(err.message || err);
      })
    },
    handleSelect(item) {
      this.tempFee = item
    },
    async getItems(row,expandedRows){
      
      if(row.children.length>1) return
      this.meta.loading = true
      let res = await api.BedTypeFee.query({type:row.type})
      if(res.items.length>0){
        for(var i = 0;i<res.items.length;i++){
          let fee = await api.FeeStandard.query({code:res.items[i].chargeCode})
          if(fee && fee.items.length>0){
            delete fee.items[0].id
            res.items[i] = Object.assign(res.items[i],fee.items[0])
          }else{
            this.$message.error('未获取到费用相关信息')
          }
        }
        this.appendFeeItem(row.id,res.items,'add')
      }
      this.meta.loading = false
     
    },
    appendFeeItem(id,item,type){
      try {
        this.wrapBedList.forEach((element)=>{
        if(element.id == id){
          if(type == 'add'){
            if(Array.isArray(item)){//是数组，第一次赋值,对象是新增
              element.children = item.concat([{name:"add"}])
            }else{
              element.children.splice(element.children.length -1 ,0,item)
            }
            
          }else{
            let index = element.children.findIndex(val=>{
              return val.id == item.id
            })
            element.children.splice(index,1)
          }
          throw new Error('stop')
        }
      })
      } catch (error) {
        console.log('error==',error)
      }
    },
    delItems(bed,feeItem){
      let self = this
      this.appendFeeItem(bed.id,feeItem,'del')
      // self.$confirm("确定要取消该收费项目", "取消", { type: "warning",})
      //   .then(() => {
      //     this.meta.loading = true
      //     api.BedFee.del(feeItem.id).then(res=>{
      //       this.$message.success('取消成功')
      //       this.appendFeeItem(bedLog.id,feeItem,'del')
      //     }).catch(error=>{

      //     }).finally(()=>{
      //       this.meta.loading = false
      //     })
      //   })
      //   .catch((e) => {});
    },
    addItems(row){
      if(!this.selFeeCode) return this.$message.error('请选择要添加的费用')
      let _fee = this.feeOptions.find(ele =>{
        return ele.code == this.selFeeCode
      })
      this.appendFeeItem(row.id,_fee,'add')
      this.selFeeCode = ''
      return
      this.$confirm("确定要添加该收费项目", "取消", { type: "warning",})
        .then(() => {
          let _pra = {
            bedId:bedLog.id,
            chargeCode:this.tempFee.code
          }
          
           this.meta.loading = true
          api.BedFee.save(_pra).then(res=>{
            this.$message.success('添加成功')
            this.tempFee = Object.assign(this.tempFee,res)
            this.appendFeeItem(bedLog.id,this.tempFee,'add')
            this.tempFee = null
            this.bedLog.state = ''
          }).catch(error=>{

          }).finally(()=>{
            this.meta.loading = false
          })
        })
        .catch((e) => {});
    },
    showBed(type,row){
      this.selInfo.bedId = row ? row.bedId : ''
      this.selInfo.id = row ? row.id : ''
      this.selInfo.type = type
      this.meta.showBed = true
    },
    changeMainBed(changeId){
      let self = this
      this.meta.loading = true
      api.changeMainBed(this.mainBedLogId,changeId).then(res=>{
        this.$message.success('调换主床成功')
        this.getHasBed()
      }).catch(error=>{
        this.$message.error('调换主床失败')
      }).finally(()=>{
        this.meta.loading = false
      })
      
    },
    async cancelWarpBed(bedLogId){
      let self = this
      self.$confirm("确定要取消包床吗", "取消", { type: "warning",})
        .then(() => {
          self.meta.loading = true;
          
          api.cancelWarpBed(bedLogId).then(res=>{
            self.$message.success("取消包床成功");
            self.getHasBed();
          }).catch(error=>{

          }).finally(()=>{
            self.meta.loading = false;
          })
        })
        .catch((e) => {});
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if(row.name == 'add' && columnIndex == 1){
        return [2, 2];
      }else{
        return [1, 1];
      }
    },
  },
};
</script>

<style scoped>
.activeSel{
  color: #409EFF;
}

.rotate{
   -ms-transform:rotate(90deg); /* IE 9 */
  -webkit-transform:rotate(90deg); /* Safari and Chrome */
  transform:rotate(90deg);
}
</style>
